import React, { Component, Fragment } from 'react';
import { compose } from '../../../reactApolloCompat';
import { withRouter } from '../../../util/withRouter';
import { withSnackbarMessage } from '../../../context/SnackbarMessage';
import { IconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../../component/form/Grid';
import Paper from '@mui/material/Paper';
import Spinner from '../../../component/form/v2/Spinner';
import Typography from '../../../component/Typography';
import SimpleValuableDetailsModal from '../Common/SimpleValuableDetailsModal';
import BiggerMessageBar from '../../../component/BiggerMessageBar';
import PrimaryButton, { DestroyButton, OutlineButton, SaveButton } from '../../../component/form/PrimaryButton';
import DataFormView from '../../../component/form/v2/DataFormView';
import { CheckoutItemFragment, sanitizeFuneralAdminCheck, saveFuneralAdminCheck } from './CheckoutItemConstants';
import { dateTimeToString, dateToString, niceDateTimeFromString } from '../../../util/date';
import ColumnLayout from '../../../component/ColumnLayout';
import Checkbox from '../../../component/form/Checkbox';
import cx from 'classnames';
import { joinDefined, prettyDisposal } from '../../../util/strings';
import LinkButton from '../../../component/form/LinkButton';
import { flattenBookingItems, PreloadProducts, ProductConfig } from '../../../util/products';
import { ImageList, ImageListItem } from '../../../component/form/ImageList';
import history from '../../../History';
import Table, { TableCell, TableHeaderCell, TableHeaderRow, TableRow } from '../../../component/form/Table';
import ValuablesForm from '../Common/ValuablesForm';
import CheckoutForm from '../Common/CheckoutForm';
import PhotoModal from '../../../component/form/PhotoModal';
import { isContactDefined, isRelatedObjectDefined } from '../../../util/bookable';
import StaffAutoComplete from '../../../component/form/StaffAutoComplete';
import { isRelatedObjectUndefined } from '../../../util/graphql';
import { getUser } from '../../../util/sessions';
import cloneDeep from 'lodash.clonedeep';
import moment from 'moment';
import { InlineField, InlineFieldRightAlignChildren, InlineHeader } from '../../../component/form/Inline';
import Icon from '@mui/material/Icon';
import { getDressingStatus, releaseFromCheckout, unreleaseFromCheckout } from '../MortuaryItemConstants';
import { indexOf } from '../../../util/arrays';
import {
    filterAdminChecks,
    loadAdminSummary,
    saveCheckoutChecklistFunc
} from '../../funeral/adminSummary/GetSaveAdminSummary';
import { isNullOrUndefined } from '../../../util/objects';
import GatedComponent from '../../../component/GatedComponent';
import AlertModal from '../../../component/form/AlertModal';
import TextField from '../../../component/form/TextField';
import Label from '../../../component/form/Label';
import InputAdornment from '@mui/material/InputAdornment';
import RecordDrawer from '../../workQueue2/RecordDrawer';
import ErrorFallback from '../../../component/ErrorFallback';
import { withErrorBoundary } from '@sentry/react';
import {
    BackIcon,
    CloseIcon,
    EditIcon,
    ExclamationTriangleIcon,
    TickCircleIcon,
    TickIcon
} from '../../../component/IconIndex';
import { VALUABLES_LOCATION_OPTIONS } from '../../funeral/details/valuables-modal/ValuablesConstants';

const emptyUser = { ID: 0 };

class CheckoutItem extends Component {
    state = {
        loadingProducts: true,
        checklistData: null,
        openValuableModal: false,
        valuableItemId: null,
        staff1: emptyUser,
        staff2: emptyUser,
        selectedPhoto: null,
        loadingChecks: {},
        loadingAllChecks: false,
        alertModalState: {
            open: false,
            title: null,
            message: null
        }
    };
    _isMounted = false;

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        const { form } = this.props;
        const funeralId = form.getState('ID');
        const me = this;

        if (funeralId) {
            this.setState({ loadingAllChecks: true });
            loadAdminSummary(funeralId).then(adminData => {
                this._isMounted &&
                    saveCheckoutChecklistFunc(funeralId, adminData.adminSummary, adminData.original).then(
                        saveResult => {
                            form.setState(
                                {
                                    AdminChecks: saveResult
                                        ? saveResult.updateFuneral.AdminChecks
                                        : adminData.adminSummary.AdminChecks
                                },
                                true
                            );
                            this._isMounted && me.setState({ loadingAllChecks: false });
                        }
                    );
            });

            const products = form.getState('Disposal.DisposalBookingItems');

            if (products && products.length > 0) {
                PreloadProducts(this, products).then(
                    () => this._isMounted && this.setState({ loadingProducts: false })
                );
            } else {
                this.setState({ loadingProducts: false });
            }
        }
    }

    render() {
        const { classes, form } = this.props;
        const { selectedPhoto, openValuableModal, valuableItemId, alertModalState, loading } = this.state;

        return (
            <Grid container>
                <Grid item xs={12}>
                    <InlineFieldRightAlignChildren lineHeight={'inherit'}>
                        {form.getField('Cancelled') && (
                            <BiggerMessageBar messageType="error">This record is cancelled.</BiggerMessageBar>
                        )}
                        <Typography variant="display4" gutterBottom className={classes.pageTitle}>
                            <span>Checkout {form.getState('LegacyKey')}</span>
                            <small className={classes.header}>
                                {`${joinDefined(
                                    [form.getState('FirstName'), form.getState('MiddleName'), form.getState('Surname')],
                                    ' '
                                )}`}
                            </small>
                        </Typography>
                        <div style={{ marginBottom: 6 }}>
                            <InlineField style={{ alignItems: 'end' }}>
                                <PrimaryButton onClick={this.backButtonFunction}>
                                    <BackIcon /> Back
                                </PrimaryButton>

                                <OutlineButton
                                    target="_blank"
                                    onClick={() =>
                                        this.viewFuneralDetails(form.getState('ID'), form.getState('LegacyKey'))
                                    }
                                >
                                    View Funeral Record
                                </OutlineButton>
                                <RecordDrawer funeralId={form.getField('ID')} legacyKey={form.getField('LegacyKey')} />
                            </InlineField>
                        </div>
                    </InlineFieldRightAlignChildren>
                </Grid>

                <Paper
                    className={cx(classes.paper, classes.bodyPadding)}
                    elevation={0}
                    style={{ position: 'relative' }}
                >
                    {!!loading && this.renderLoading()}
                    <ColumnLayout>
                        {this.renderLeftColumn()}
                        {this.renderRightColumn()}
                    </ColumnLayout>
                </Paper>

                <SimpleValuableDetailsModal
                    open={openValuableModal}
                    onClose={() => this.setState({ openValuableModal: false, valuableItemId: null })}
                    context={this}
                    itemId={valuableItemId}
                    parentId={form.getState('ID')}
                    noChanging
                    onSaved={this.onSaveValuable}
                />

                <PhotoModal photo={selectedPhoto} onClose={() => this.setState({ selectedPhoto: null })} />
                <AlertModal
                    {...alertModalState}
                    placeholder={'Please enter a comment for staff to review and action...'}
                    onCancel={() => this.closeAlertModal()}
                />
            </Grid>
        );
    }

    renderLeftColumn() {
        const { classes, form } = this.props;
        const { staff1, staff2 } = this.state;

        const isNotReleased =
            !form.getField('DatetimeReadyForMortuaryCheckout') && !form.getField('DatetimeOfMortuaryCheckout');
        const isComplete = !!form.getField('DatetimeOfMortuaryCheckout');
        const meUser = getUser();
        const meID = Number(meUser?.ID);
        const setStaffMe = e => {
            this.setState(({ staff1, staff2 }) => {
                const isStaff1Me = Number(staff1?.ID) === meID;
                const isStaff2Me = Number(staff2?.ID) === meID;
                if (e.target.checked) {
                    if (!Number(staff1?.ID)) {
                        return { staff1: meUser };
                    } else if (!isStaff1Me) {
                        return { staff2: meUser }; // replace whatever is there
                    }
                    return null;
                } else {
                    if (isStaff1Me) {
                        return { staff1: emptyUser };
                    } else if (isStaff2Me) {
                        return { staff2: emptyUser };
                    }
                }
                return null;
            });
        };
        return (
            <Grid container spacing={3} className={classes.column} style={{ position: 'relative' }}>
                {isNotReleased && (
                    <div
                        style={{
                            zIndex: 99,
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0,
                            background: '#FFFFFF99'
                        }}
                    >
                        <BiggerMessageBar messageType="error">
                            Deceased has not been released to checkout.
                        </BiggerMessageBar>
                    </div>
                )}
                {isComplete && (
                    <div style={{ marginBottom: -8, width: '100%' }}>
                        <BiggerMessageBar>This item has already completed Mortuary Checkout.</BiggerMessageBar>
                    </div>
                )}

                {!isComplete && (
                    <Grid bucket>
                        <Grid item xs={12}>
                            <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                                Checkout Staff
                            </Typography>
                            <InlineHeader header="Who is performing the checkout?">
                                <Checkbox
                                    label="I am one of the checkout staff"
                                    checked={Number(staff1?.ID) === meID || Number(staff2?.ID) === meID}
                                    onChange={setStaffMe}
                                    className={classes.floatRight}
                                />
                            </InlineHeader>
                        </Grid>

                        <Grid item xs={6}>
                            <StaffAutoComplete
                                label={'Checkout Staff 1'}
                                placeholder="Select Staff 1..."
                                selectProps={{ multiple: false }}
                                onSelect={(_, user) => this.onSelectStaff('staff1', user)}
                                value={staff1}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <StaffAutoComplete
                                label={'Checkout Staff 2'}
                                placeholder="Select Staff 2..."
                                selectProps={{ multiple: false }}
                                onSelect={(_, user) => this.onSelectStaff('staff2', user)}
                                value={staff2}
                            />
                        </Grid>
                    </Grid>
                )}
                <div style={{ margin: -8 }}>{this.renderCheckList()}</div>
            </Grid>
        );
    }

    getMissingList() {
        const missingList = [];
        const { form } = this.props;

        /* check certification requirements */
        const isCremation = form.getState('Disposal.CrematedOrBuried') === 'Cremated';
        const needsReferee = !!isCremation && !(form.getState('Certification.TypeOfBdmDeathCertificate') === 'Coroner');
        if (!!needsReferee) {
            if (!form.getState('RefereeCremationCheck')) {
                missingList.push('Referee Documents are missing.');
            }
            if (!isContactDefined(form.getState('Certification.Referee'))) {
                missingList.push('Referee Doctor is not assigned.');
            }
        }
        const hasPacemaker = !!isCremation && !!form.getState('RemovePacemaker');
        const yetToRemovePacemaker = !!hasPacemaker && !!form.getState('RemovePacemakerPending');
        if (!!yetToRemovePacemaker) {
            missingList.push('Pacemaker has not been removed.');
        }

        return missingList;
    }

    renderRightColumn() {
        const { classes, form } = this.props;
        const { loading, loadingProducts } = this.state;
        const isComplete = form.getField('DatetimeOfMortuaryCheckout');
        const isReleased = form.getField('DatetimeReadyForMortuaryCheckout');
        const isReturned = form.getField('MortuaryActionReturnedReason');
        const isCoffinReady = form.getField('Disposal.IsCoffinPrepared');
        const estimatedDeceasedWeight = Number(form.getField('EstimatedDeceasedWeight') || 0);
        const tabURLSegment = 'mortuary';
        const adminChecks =
            !!form.getState('AdminChecks') &&
            filterAdminChecks(form, tabURLSegment, form.getState('AdminChecks')).filter(item => item.include);

        const missing = this.getMissingList();
        const msgNotReady = !!missing.length && (
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <BiggerMessageBar messageType="warning">
                        Complete Checkout with warnings:
                        <ul style={{ margin: 0 }}>
                            {missing.map((e, i) => (
                                <li key={i}>
                                    <strong>{e}</strong>
                                </li>
                            ))}
                        </ul>
                    </BiggerMessageBar>
                </Grid>
            </Grid>
        );

        return (
            <Grid container spacing={3} className={classes.column} style={{ position: 'relative' }}>
                {this.renderStaff()}

                {this.renderTopTextFields()}

                {this.renderPhotos()}

                {this.renderCoffinDetails()}

                {this.renderValuablesTable()}

                <Grid bucket>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            <span>Complete Mortuary Checkout</span>
                        </Typography>

                        {(!!isReleased && (
                            <Typography variant="subtitle1">
                                Released to Mortuary Checkout on {niceDateTimeFromString(isReleased)}
                                {!!isComplete && <div>Checkout completed on {niceDateTimeFromString(isComplete)}</div>}
                            </Typography>
                        )) ||
                            (!!isReturned && <BiggerMessageBar messageType="error">{isReturned}</BiggerMessageBar>) || (
                                <Typography variant="subtitle1">Waiting for Mortuary staff to release.</Typography>
                            )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Label text="Weight of Deceased" />
                        <TextField
                            placeholder={'Enter the estimated weight...'}
                            type="number"
                            form={form}
                            name="EstimatedDeceasedWeight"
                            disabled={!!isComplete || !isReleased}
                            min={0}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">KG</InputAdornment>
                            }}
                        />
                    </Grid>

                    {!!msgNotReady && (
                        <Grid item xs={12}>
                            {msgNotReady}
                        </Grid>
                    )}

                    <InlineField>
                        {!loadingProducts && (
                            <CheckoutForm
                                form={form}
                                mortuaryListData={!!adminChecks && adminChecks.map(e => e.adminCheck)}
                            />
                        )}
                        {!!isReleased && !isComplete && (
                            <GatedComponent showComponentCode={'FM_ACCESS_Mortuary_Process'}>
                                {() => (
                                    <SaveButton
                                        disabled={loading || !estimatedDeceasedWeight || !isCoffinReady}
                                        onClick={() => this.handleReleaseFromCheckout()}
                                    >
                                        <TickCircleIcon />
                                        Complete Checkout
                                    </SaveButton>
                                )}
                            </GatedComponent>
                        )}

                        {!isReleased && (
                            <OutlineButton onClick={() => this.goCheckoutFunction()}>
                                <BackIcon /> View Mortuary Action
                            </OutlineButton>
                        )}
                        {!!isComplete && (
                            <SaveButton disabled>
                                <TickCircleIcon />
                                Checkout Completed
                            </SaveButton>
                        )}
                    </InlineField>
                </Grid>
            </Grid>
        );
    }

    renderLoading() {
        return (
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    background: '#FFFFFF99',
                    margin: -24,
                    zIndex: 9
                }}
            >
                {this.renderLoadingWidget()}
            </div>
        );
    }

    renderLoadingWidget() {
        return (
            <div>
                <Spinner />
                &nbsp;<span>Loading...</span>
            </div>
        );
    }

    renderPhotos() {
        const { form, classes } = this.props;
        const photos = form.getField('DeceasedPhotos') || [];
        const refPhoto = form.getField('ReferencePhoto') || [];
        const refPhotoID = refPhoto && refPhoto.ID;
        return (
            <Grid bucket={true} container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        <span>Reference Photos</span>
                    </Typography>

                    {photos.length > 0 ? (
                        <ImageList>
                            {photos.map(
                                (photo, i) =>
                                    refPhotoID === photo.ID && (
                                        <ImageListItem
                                            key={i}
                                            title={'Mortuary Reference Photo'}
                                            value={{
                                                image: photo.AbsoluteLink,
                                                label: photo.Name,
                                                tileWidth: 2,
                                                tileHeight: 2
                                            }}
                                            onClick={() => this.setState({ selectedPhoto: photo })}
                                        />
                                    )
                            )}
                            {photos.map(
                                (photo, i) =>
                                    refPhotoID !== photo.ID && (
                                        <ImageListItem
                                            key={i}
                                            value={{
                                                image: photo.AbsoluteLink,
                                                label: photo.Name
                                            }}
                                            onClick={() => this.setState({ selectedPhoto: photo })}
                                        />
                                    )
                            )}
                        </ImageList>
                    ) : (
                        <Typography variant="subtitle1">No photos supplied.</Typography>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderValuablesTable() {
        const { classes, form } = this.props;
        const valuables = form.getState('ValuableItems') || [];
        const columnLabels = ['Status', 'Description', 'QTY', 'Final Action', 'Signed', 'Current Location', ''];
        const tableRows = isEnabled =>
            valuables.map((valuable, index) => {
                const finalAction = valuable.FinalAction || (!!valuable.ToBeReturned && 'Return') || 'Unsure';
                const isDone =
                    ('Returned' === valuable.CurrentLocation && 'Return' === finalAction) ||
                    ('Placed' === valuable.CurrentLocation && 'Remain' === finalAction);
                return (
                    <TableRow
                        key={index}
                        onClick={isEnabled ? e => this.viewValuableItem(e, valuable.ID) : null}
                        className={isEnabled ? classes.clickThis : null}
                    >
                        <TableCell dataLabel={columnLabels[0]} centred tiny>
                            {isDone ? (
                                <TickCircleIcon className={classes.good} title="Item is actioned" />
                            ) : (
                                <ExclamationTriangleIcon className={classes.warning} title="Item is not actioned" />
                            )}
                        </TableCell>
                        <TableCell dataLabel={columnLabels[1]}>
                            {valuable.Description}
                            <br />
                            <small>{valuable.Note}</small>
                        </TableCell>
                        <TableCell dataLabel={columnLabels[2]}>x{valuable.Quantity}</TableCell>
                        <TableCell dataLabel={columnLabels[3]}>{finalAction}</TableCell>
                        <TableCell dataLabel={columnLabels[4]} centred tiny>
                            {valuable.Signed ? <TickIcon color={'primary'} /> : <CloseIcon color={'disabled'} />}
                        </TableCell>
                        <TableCell dataLabel={columnLabels[5]}>
                            {
                                (
                                    VALUABLES_LOCATION_OPTIONS.find(o => o.value === valuable.CurrentLocation) || {
                                        label: 'Missing'
                                    }
                                ).label
                            }
                            <br />
                            <small>{valuable.CurrentLocationDetail}</small>
                        </TableCell>
                        <TableCell dataLabel={columnLabels[6]} pad={false} centred tiny>
                            <IconButton
                                title={'Edit'}
                                onClick={isEnabled ? e => this.viewValuableItem(e, valuable.ID) : null}
                            >
                                <EditIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            });

        return (
            <GatedComponent
                showComponentCode={'FM_ACCESS_Mortuary_Valuables_View'}
                isEnabledCode={'FM_ACCESS_Mortuary_Valuables_Edit'}
            >
                {isEnabled => {
                    return (
                        <Grid bucket={true} xs={12}>
                            <Grid item xs={12}>
                                <Typography variant="headline" gutterBottom className={cx(classes.pageTitle)}>
                                    Valuables
                                </Typography>

                                <div className={classes.tableData}>
                                    {valuables.length > 0 ? (
                                        <Table>
                                            <TableHeaderRow>
                                                {columnLabels.map(label => (
                                                    <TableHeaderCell key={label}>{label}</TableHeaderCell>
                                                ))}
                                            </TableHeaderRow>
                                            {tableRows(isEnabled)}
                                        </Table>
                                    ) : (
                                        <Typography variant="subtitle1">
                                            Deceased has no record of valuables.
                                        </Typography>
                                    )}
                                </div>
                            </Grid>
                            <InlineField>
                                <ValuablesForm form={form} />
                            </InlineField>
                        </Grid>
                    );
                }}
            </GatedComponent>
        );
    }

    renderCoffinDetails() {
        const { loadingProducts } = this.state;
        const { form, classes } = this.props;
        const coffinProducts = (form.getField('Disposal.DisposalBookingItems') || [])
            .map(b => {
                const obj = structuredClone(b);
                const hasProduct = ProductConfig.productMap[obj.ProductID];
                const product = structuredClone(hasProduct ?? { variations: [] });
                if (!!hasProduct) {
                    if (obj.Quantity && hasProduct.urlSegment === 'coffins') {
                        product.tileWidth = 2;
                        product.tileHeight = 2;
                    }
                    obj.titleObj = product.variations?.find(e => e.id === obj.VariationID) || product;
                }
                return { ...obj, product };
            })
            .sort((a, b) => (a.product?.urlSegment === 'coffins' ? -1 : 1));
        const isComplete = !!form.getField('DatetimeOfMortuaryCheckout');
        return (
            <Grid container bucket={true}>
                <Grid item xs={12}>
                    <Typography
                        variant="headline"
                        gutterBottom
                        className={cx(classes.pageTitle, classes.coffinDetailsHeader)}
                    >
                        <span>Coffin Details</span>
                    </Typography>
                    <Checkbox
                        form={form}
                        name="Disposal.IsCoffinPrepared"
                        label="Coffin is trimmed and ready"
                        disabled={isComplete}
                    />
                    {loadingProducts ? (
                        this.renderLoadingWidget()
                    ) : coffinProducts.length > 0 ? (
                        <Fragment>
                            <ImageList>
                                {coffinProducts.map(
                                    (obj, i) =>
                                        2 === (obj.product && obj.product.tileWidth) && (
                                            <ImageListItem key={i} value={obj.product} quantity={obj.Quantity} />
                                        )
                                )}
                                {coffinProducts.map(
                                    (obj, i) =>
                                        2 !== (obj.product && obj.product.tileWidth) && (
                                            <ImageListItem key={i} value={obj.product} quantity={obj.Quantity} />
                                        )
                                )}
                            </ImageList>
                            <ul style={{ marginBottom: 0 }}>
                                {coffinProducts.map((obj, i) => {
                                    return (
                                        <li key={i} className={Number(obj.Quantity) === 0 ? classes.strikeout : ''}>
                                            {Number(obj.Quantity) === 0 ? '' : 'x' + Number(obj.Quantity)}{' '}
                                            {obj.titleObj ? (
                                                <>
                                                    <strong>{obj.titleObj.internalId}</strong>: {obj.titleObj.title}
                                                </>
                                            ) : (
                                                'Unknown coffin'
                                            )}
                                            {1 === 2 && !!obj.Returns ? ' | To be returned' : ''}
                                            {!!obj.Comment ? ' | Comment: ' + obj.Comment : ''}
                                        </li>
                                    );
                                })}
                            </ul>
                        </Fragment>
                    ) : (
                        <BiggerMessageBar messageType="error">No coffin has been selected.</BiggerMessageBar>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderTopTextFields() {
        const { form, classes } = this.props;

        let latestDate = moment().add(100, 'years');
        let viewing = null;
        const items = form.getState('PlaceOfViewingItems') || [];
        items.forEach(e => {
            const theDate = moment(e.Start || e.Date);
            if (moment(theDate).isValid() && theDate < latestDate) {
                latestDate = theDate;
                viewing = e;
            }
        });
        const isGraveside = form.getField('PlaceOfService.Type') === 'Graveside';
        const service = !!isGraveside ? form.getState('Disposal') : form.getState('PlaceOfService');
        const getRelease = () => {
            const startV = !!viewing && (viewing.Start || viewing.Date);
            const startS = !!service && (service.Start || service.Date);
            if (startV && !startS) return viewing;
            if (startS && !startV) return service;
            return moment(startV).isBefore(startS) ? viewing : service;
        };
        const release = getRelease();
        const isCremation = form.getState('Disposal.CrematedOrBuried') === 'Cremated';
        const hasPacemaker = !!isCremation && !!form.getState('RemovePacemaker');
        const yetToRemovePacemaker = !!hasPacemaker && !!form.getState('RemovePacemakerPending');
        const needsReferee = !!isCremation && !(form.getState('Certification.TypeOfBdmDeathCertificate') === 'Coroner');
        const isCrypt =
            (form.getState('Disposal.CrematedOrBuried') === 'Buried' ||
                form.getState('Disposal.CrematedOrBuried') === 'Repatriated') &&
            (form.getState('Grave.GroundDescription') === 'Crypt' || form.getState('Grave.DepthOption') === 'Crypt');

        return (
            <Fragment>
                <Grid container bucket={true}>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            {prettyDisposal(form.getState('Disposal.CrematedOrBuried'), false)}
                            {!!isCremation && (
                                <span className={classes.lightGreyHeader}>
                                    {!!needsReferee ? (
                                        !!isContactDefined(form.getState('Certification.Referee')) ? (
                                            !!form.getState('RefereeCremationCheck') ? (
                                                <Fragment>
                                                    Referee Completed{' '}
                                                    <TickIcon className={classes.icon} title={'Completed'} />
                                                </Fragment>
                                            ) : (
                                                <span className={classes.warning}>Referee In Progress</span>
                                            )
                                        ) : (
                                            <span className={classes.warning}>Referee NOT ASSIGNED</span>
                                        )
                                    ) : (
                                        'Referee Not Required'
                                    )}
                                </span>
                            )}
                            {!!isCrypt && <span className={classes.lightGreyHeader}>for Crypt</span>}
                        </Typography>
                        <Typography variant="subtitle1">
                            Release to:{' '}
                            {!isNullOrUndefined(release) && !!isContactDefined(release.Location) ? (
                                <span className={classes.purpleText}>{release.LocationFlattened}</span>
                            ) : (
                                'No release specified.'
                            )}
                        </Typography>
                        {!isNullOrUndefined(release) &&
                            !isNullOrUndefined(release.Comment) &&
                            !!release.Comment.trim() && (
                                <Typography variant="subtitle1">
                                    Comments: <i>{release.Comment}</i>
                                </Typography>
                            )}
                    </Grid>
                    <Grid item sm={6}>
                        <Typography variant="subtitle1">
                            Viewing:{' '}
                            <span className={classes.purpleText}>
                                {!!form.getField('PlaceOfViewingRequired') && !isNullOrUndefined(viewing)
                                    ? !!viewing.Date && !!viewing.Time
                                        ? niceDateTimeFromString(viewing.Date + ' ' + viewing.Time)
                                        : 'Date/time not provided.'
                                    : 'No viewings.'}
                            </span>
                        </Typography>
                    </Grid>
                    <Grid item sm={6}>
                        <Typography variant="subtitle1">
                            Service:{' '}
                            <span className={classes.purpleText}>
                                {!isNullOrUndefined(service) && service.Type !== 'No Service No Attendance'
                                    ? !!service.Date && !!service.Time
                                        ? niceDateTimeFromString(service.Date + ' ' + service.Time)
                                        : 'Date/time not provided.'
                                    : 'No service.'}
                            </span>
                        </Typography>
                    </Grid>
                </Grid>

                <Grid bucket={true}>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            <span>Dressing</span>
                        </Typography>
                        <Typography variant="subtitle1">{getDressingStatus(form)}</Typography>
                    </Grid>
                </Grid>

                <Grid bucket={true}>
                    <Grid item xs={12}>
                        <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                            <span>Preparation Notes</span>
                        </Typography>

                        {form.getState('IsBariatric') && (
                            <BiggerMessageBar messageType="warning">
                                <strong>Bariatric</strong>. Follow safe lifting techniques and get assistance.
                            </BiggerMessageBar>
                        )}
                        {form.getState('IsInfectious') && (
                            <BiggerMessageBar messageType="warning">
                                <strong>Infectious</strong>. Follow infection control protocols and use protective gear.
                            </BiggerMessageBar>
                        )}
                        {form.getState('IsDecomposed') && (
                            <BiggerMessageBar messageType="warning">
                                <strong>Decomposed</strong>. Take precautions when handling or exposing.
                            </BiggerMessageBar>
                        )}

                        <Typography variant="subtitle1" className={classes.notesPre}>
                            {form.getState('CoffinComment') || 'No additional notes.'}
                        </Typography>

                        {!!isCrypt && (
                            <BiggerMessageBar messageType="info">Embalming is required for Crypt.</BiggerMessageBar>
                        )}

                        {!!hasPacemaker &&
                            (!!yetToRemovePacemaker ? (
                                <BiggerMessageBar messageType="error">
                                    Pacemaker must be removed for cremation.
                                </BiggerMessageBar>
                            ) : (
                                <BiggerMessageBar messageType="info">Confirm pacemaker was removed.</BiggerMessageBar>
                            ))}
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    renderCheckList() {
        const { classes, form } = this.props;
        const { loadingAllChecks } = this.state;
        const isComplete = !!form.getField('DatetimeOfMortuaryCheckout');
        const disabled = isRelatedObjectUndefined(this.state.staff1) || isRelatedObjectUndefined(this.state.staff2);

        const tabURLSegment = 'mortuary';

        return (
            <GatedComponent showComponentCode={'FM_ACCESS_Mortuary_Checklist'}>
                {() => {
                    return (
                        <Grid container spacing={3} style={{ margin: 0, padding: 9, width: '100%' }}>
                            <Grid item xs={12}>
                                <DestroyButton style={{ float: 'right' }} onClick={() => this.onUnrelease()}>
                                    <Icon style={{ marginRight: 6 }}>report</Icon> Cancel Checkout...
                                </DestroyButton>
                                <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                                    <span>Checklist </span>
                                </Typography>
                                {!!disabled && !isComplete && (
                                    <small className={classes.bad}>
                                        Please nominate two checkout staff to proceed with the checkout.
                                    </small>
                                )}
                            </Grid>

                            {loadingAllChecks
                                ? this.renderLoadingWidget()
                                : !!form.getState('AdminChecks') &&
                                  filterAdminChecks(form, tabURLSegment, form.getState('AdminChecks'))
                                      .filter(item => item.include)
                                      .map(item => this.renderCheckListItem(item.adminCheck, item.index))}
                        </Grid>
                    );
                }}
            </GatedComponent>
        );
    }

    renderCheckListItem(item, index) {
        const { classes, form } = this.props;
        const isComplete = !!form.getField('DatetimeOfMortuaryCheckout');
        const loading = this.state.loadingChecks[item.ID] === true;
        const disabled =
            isRelatedObjectUndefined(this.state.staff1) || isRelatedObjectUndefined(this.state.staff2) || loading;
        const assignToDisabled = isRelatedObjectDefined(item._join.FuneralAdminCheck.Task);

        let assignedTo = '';

        if (isRelatedObjectDefined(item._join.FuneralAdminCheck.Member)) {
            assignedTo += joinDefined(
                [item._join.FuneralAdminCheck.Member.FirstName, item._join.FuneralAdminCheck.Member.Surname],
                ' '
            );
        }

        if (isRelatedObjectDefined(item._join.FuneralAdminCheck.MortuaryMember)) {
            assignedTo +=
                ' and ' +
                joinDefined(
                    [
                        item._join.FuneralAdminCheck.MortuaryMember.FirstName,
                        item._join.FuneralAdminCheck.MortuaryMember.Surname
                    ],
                    ' '
                );
        }

        return (
            <Grid
                key={index}
                item
                xs={12}
                bucket={true}
                className={classes.checkRow}
                style={{ pointerEvents: !!disabled ? 'none' : 'auto' }}
            >
                <Grid container spacing={3} className={classes.hideSecondChild}>
                    <Grid item xs={12}>
                        <Checkbox
                            label={item.Title}
                            checked={!isNullOrUndefined(item._join.FuneralAdminCheck.Checked)}
                            onChange={e => this.onAdminItemChecked(e.target.checked, item.ID, index)}
                            disabled={disabled}
                        />
                        <div style={{ float: 'right' }}>
                            {isRelatedObjectDefined(item._join.FuneralAdminCheck.Task) &&
                            item._join.FuneralAdminCheck.Task.AssignedMembers.length === 0 ? (
                                <LinkButton
                                    className={classes.assignText}
                                    text={'Reassign To Funeral Staff'}
                                    onClick={() => this.reassignToFuneralStaff(item.ID, index)}
                                    disabled={!!loading || isComplete}
                                />
                            ) : (
                                !!isNullOrUndefined(item._join.FuneralAdminCheck.Checked) && (
                                    <LinkButton
                                        className={!!assignToDisabled ? classes.assignTextDisabled : classes.assignText}
                                        text={
                                            assignToDisabled
                                                ? 'Assigned To Funeral Staff'
                                                : 'Assign to Funeral Staff...'
                                        }
                                        onClick={() => this.assignToFuneralStaff(item.ID, index)}
                                        disabled={assignToDisabled || isComplete}
                                    />
                                )
                            )}
                        </div>
                        {loading && <Spinner />}

                        <Typography variant="subtitle1" className={classes.checklistStaff}>
                            {assignedTo}
                        </Typography>
                    </Grid>
                    {isRelatedObjectDefined(item._join.FuneralAdminCheck.Task) && (
                        <div className={classes.noteBox}>
                            <BiggerMessageBar
                                messageType={
                                    !!item._join.FuneralAdminCheck.Task.Completed
                                        ? 'good'
                                        : item._join.FuneralAdminCheck.Task.AssignedMembers.length > 0
                                        ? 'info'
                                        : 'error'
                                }
                            >
                                <div>
                                    {item._join.FuneralAdminCheck.Task.AssignedMembers.length > 0
                                        ? `This item ${
                                              !!item._join.FuneralAdminCheck.Task.Completed ? 'was' : 'is'
                                          } assigned to ${joinDefined(
                                              item._join.FuneralAdminCheck.Task.AssignedMembers.map(
                                                  assignedMember =>
                                                      `${assignedMember.FirstName} ${assignedMember.Surname}`
                                              ),
                                              ' and '
                                          )}.`
                                        : 'THIS TASK HAS NO FUNERAL STAFF ASSIGNED TO IT!'}
                                </div>
                                {!item._join.FuneralAdminCheck.Task.Completed && (
                                    <div>
                                        <i>{item._join.FuneralAdminCheck.Task.RequiredAction}</i>
                                    </div>
                                )}
                            </BiggerMessageBar>
                        </div>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderStaff() {
        const { form, classes } = this.props;
        const renderStaffList = staffType =>
            form
                .getField(staffType)
                .filter(e => !isRelatedObjectUndefined(e.Member))
                .map((e, i, a) => {
                    return (
                        <span key={i}>
                            <span className={classes.purpleText}>
                                {joinDefined([e.Member.FirstName, e.Member.Surname], ' ')}
                            </span>
                            {1 + i === a.length ? '.' : ', '}
                        </span>
                    );
                });
        const listArrangers = renderStaffList('Arrangers');
        const listCoordinators = renderStaffList('Coordinators');
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Typography variant="headline" gutterBottom className={classes.pageTitle}>
                        Funeral Staff
                    </Typography>
                    <Typography variant="subtitle1">
                        <span>Arrangers: </span>
                        {listArrangers.length ? listArrangers : ' none assigned.'}
                    </Typography>
                    <Typography variant="subtitle1">
                        <span>Coordinators: </span>
                        {listCoordinators.length ? listCoordinators : ' none assigned.'}
                    </Typography>
                </Grid>
            </Grid>
        );
    }

    onSelectStaff(propertyName, staff) {
        this.setState({ [propertyName]: staff || emptyUser });
    }

    onUnrelease = () => {
        const { form } = this.props;
        const reason = window.prompt(
            'Are you sure you want to return this item to the Mortuary Action List?\n\nPlease enter a reason...',
            ''
        );
        if (reason === null) return null;
        unreleaseFromCheckout(form.getState('ID'), reason).then(() => history.push('/mortuary'));
    };

    onAdminItemChecked(checked, id, index) {
        const { form } = this.props;
        const AdminChecks = form.getState('AdminChecks');
        const funeralAdminCheck = cloneDeep(AdminChecks[index]._join.FuneralAdminCheck);

        //set or remove the timestamp and assigned members
        if (checked) {
            const { staff1, staff2 } = this.state;
            funeralAdminCheck.Member = staff1;
            funeralAdminCheck.MortuaryMember = staff2;
            funeralAdminCheck.Checked = dateTimeToString(new Date());
        } else {
            funeralAdminCheck.Member = emptyUser;
            funeralAdminCheck.MortuaryMember = emptyUser;
            funeralAdminCheck.Checked = null;
        }

        this.sanitizeAndSaveFuneralAdminCheck(id, index, funeralAdminCheck);
    }

    assignToFuneralStaff(id, index) {
        const { form } = this.props;
        const funeralStaff = (form.getState('Coordinators') || [])
            .concat(form.getState('Arrangers') || [])
            .map(x => x.Member);

        if (funeralStaff.length === 0) {
            this.openAlertModal('Error', 'Sorry, there are currently no Funeral Staff allocated to this funeral.');
            return;
        }
        const legacyKey = form.getState('LegacyKey');
        const AdminChecks = form.getState('AdminChecks');
        const adminCheck = AdminChecks[index];

        this.openAlertModalWithText(
            <>
                <small>Urgent Mortuary Issue for {legacyKey}</small>
                <br />
                <strong>{adminCheck.Title}</strong>
            </>,
            <>
                Assign Task to:{' '}
                {joinDefined(
                    funeralStaff.map(obj => joinDefined([obj.FirstName, obj.Surname], ' ')),
                    ', '
                )}
            </>,
            Comment => {
                const funeralAdminCheck = cloneDeep(adminCheck._join.FuneralAdminCheck);

                const { staff1, staff2 } = this.state;

                const mortUser1 = !!staff1.ID && joinDefined([staff1.FirstName, staff1.Surname?.substring(0, 1)], ' ');
                const mortUser2 = !!staff2.ID && joinDefined([staff2.FirstName, staff2.Surname?.substring(0, 1)], ' ');
                const mortUsers = joinDefined([mortUser1, mortUser2], ' and ');

                funeralAdminCheck.Task = {
                    Title: `Urgent Mortuary Issue for ${legacyKey}`,
                    Description: `${adminCheck.Title}`,
                    RequiredAction:
                        Comment || `Resolve & contact ${!!mortUsers ? mortUsers : 'Mortuary Staff'} immediately`,
                    TabURLSegment: '',
                    Due: `${dateToString(new Date())} 18:30:00`,
                    FuneralID: form.getState('ID'),
                    AssignedMembers: funeralStaff.map(user => ({
                        ID: user.ID
                    }))
                };

                this.sanitizeAndSaveFuneralAdminCheck(id, index, funeralAdminCheck);
            }
        );
    }

    reassignToFuneralStaff(id, index) {
        const { form } = this.props;
        const funeralStaff = (form.getState('Coordinators') || [])
            .concat(form.getState('Arrangers') || [])
            .map(x => x.Member);

        if (funeralStaff.length === 0) {
            console.error('no coordinators or arranges allocated to this funeral!', form.getState('ID'));
            return;
        }

        const funeralAdminCheck = cloneDeep(form.getState(`AdminChecks[${index}]._join.FuneralAdminCheck`));

        funeralAdminCheck.Task.AssignedMembers = funeralStaff.map(user => ({
            ID: user.ID
        }));

        this.sanitizeAndSaveFuneralAdminCheck(id, index, funeralAdminCheck);
    }

    sanitizeAndSaveFuneralAdminCheck(id, index, funeralAdminCheck) {
        this.setCheckLoadingState(id, true);

        const { form } = this.props;
        const AdminChecks = form.getState('AdminChecks');

        //sanitize and commit to the database
        const sanitized = sanitizeFuneralAdminCheck(cloneDeep(funeralAdminCheck));
        saveFuneralAdminCheck(sanitized).then(result => {
            if (result) {
                AdminChecks[index]._join.FuneralAdminCheck = result;
                form.setState({ AdminChecks });
            }
            this.setCheckLoadingState(id, false);
        });
    }

    handleReleaseFromCheckout = () => {
        this.setState({ loading: true });

        const { form } = this.props;
        const me = this;
        releaseFromCheckout(form.getState('ID'), form.getState('EstimatedDeceasedWeight')).then(data => {
            me.props.form.setField({ DatetimeOfMortuaryCheckout: data.DatetimeOfMortuaryCheckout }, 1);
            me.setState({ loading: false });
        });
    };

    setCheckLoadingState(index, loading) {
        //set to loading, to block other changes
        const { loadingChecks } = this.state;
        loadingChecks[index] = loading;
        this.setState({ loadingChecks });
    }

    backButtonFunction() {
        history.push('/mortuary/checkout');
    }

    goCheckoutFunction() {
        const { form } = this.props;
        const ID = form.getField('ID');
        const LegacyKey = form.getField('LegacyKey');
        history.push(`/mortuary/item/${LegacyKey}/${ID}`);
    }

    viewFuneralDetails = (id, legacyId) => {
        const path = `/funeral/${legacyId}/${id}`;
        const win = window.open(path);
        win.focus();
    };

    viewValuableItem = (evt, valuableItemId) => {
        evt.stopPropagation();
        this.setState({ valuableItemId, openValuableModal: true });
    };

    onSaveValuable = item => {
        const { Changes, Funeral, Note, ...newData } = item;
        const { form } = this.props;
        const ValuableItems = form.getState('ValuableItems') || [];
        const index = indexOf(ValuableItems, x => x.ID === item.ID);
        if (index < 0) {
            ValuableItems.push(newData);
        } else {
            Object.assign(ValuableItems[index], newData);
        }
        form.setState({ ValuableItems, Note: Note || null, ...Funeral }, 1);
        this.setState({ valuableItemId: newData.ID });
    };

    openAlertModal(title, message) {
        this.setState({
            alertModalState: {
                open: true,
                title,
                message,
                acceptInput: false,
                onAccept: null
            }
        });
    }

    openAlertModalWithText(title, message, onAccept) {
        this.setState({
            alertModalState: {
                open: true,
                title,
                message,
                acceptInput: true,
                onAccept: inputValue => {
                    onAccept(inputValue);
                    this.closeAlertModal();
                }
            }
        });
    }

    closeAlertModal() {
        const { alertModalState } = this.state;
        alertModalState.open = false;
        alertModalState.message = null;
        this.setState({ alertModalState });
    }
}

const styles = ({ spacing, typography, palette, funeralHome }) => ({
    paper: {
        padding: spacing(3),
        width: '100%'
    },
    pageTitle: {
        color: palette.contentForeground[funeralHome]
    },
    coffinDetailsHeader: {
        '@media (max-width: 1280px)': {
            marginTop: 15
        }
    },
    floatRight: {
        float: 'right'
    },
    bodyPadding: {
        // padding: '1.5rem',
        '& p': {
            fontSize: '0.875rem'
        }
    },
    column: {
        padding: `${spacing(1)} 0}`
    },
    print: {
        '@media print': {
            margin: 100
        }
    },
    header: {
        fontWeight: typography.fontWeightLight,
        marginLeft: 16,
        paddingLeft: 16,
        borderLeft: '1px solid ' + palette.action.active,
        color: palette.text.primary
    },
    secondaryHeader: {
        color: palette.action.active
    },
    lightGreyHeader: {
        fontWeight: typography.fontWeightLight,
        //color: palette.custom.lightishGrey,
        borderLeft: '1px solid ' + palette.custom.lightishGrey,
        paddingLeft: 16,
        marginLeft: 16
    },
    purpleText: {
        // color: palette.action.active
        fontWeight: typography.fontWeightMedium
    },
    tableData: {
        // paddingTop: 20
    },
    smallerButton: {
        marginRight: 15,
        '& > span': {
            fontSize: 11
        }
    },
    addButtonDesktop: {
        float: 'right',
        top: -45,
        boxShadow: 'none',
        backgroundColor: palette.button.alt.backgroundColor,
        borderRadius: 18
    },
    backButtonDesktop: {
        float: 'right',
        top: -45,
        boxShadow: 'none',
        border: '1px solid',
        color: palette.button.alt.backgroundColor,
        backgroundColor: 'white',
        borderRadius: 18,
        marginRight: 15,
        '&:hover': {
            color: 'white'
        }
    },
    notesPre: {
        whiteSpace: 'pre-wrap'
    },
    assignText: {
        float: 'right',
        fontSize: 14,
        paddingTop: 10,
        pointerEvents: 'auto'
    },
    assignTextDisabled: {
        float: 'right',
        fontSize: 14,
        paddingTop: 10
    },
    hideSecondChild: {
        flex: '1 1 auto'
    },
    checklistStaff: {
        fontSize: 14
    },
    checkRow: {
        padding: '10px 15px'
    },
    clickThis: {
        cursor: 'pointer'
    },
    noteBox: {
        margin: '-16px 12px 6px',
        width: '100%'
    },
    warning: {
        color: palette.validation.suggested
    },
    bad: {
        color: palette.validation.error
    },
    good: {
        color: palette.validation.good
    }
});
const StyledComponent = compose(withRouter, withSnackbarMessage, withStyles(styles))(CheckoutItem);
const Tabs = [
    {
        id: 'CheckoutItem',
        label: 'Mortuary Checkout',
        component: StyledComponent,
        fragment: CheckoutItemFragment,
        onLoad: data => {
            if (data.Disposal) flattenBookingItems(data.Disposal, 'DisposalBookingItems');
            if (data.Florists) data.Florists.forEach(florist => flattenBookingItems(florist, 'BookingItems'));
        }
    }
];

class CheckoutItemView extends Component {
    render() {
        return (
            <DataFormView
                tabs={Tabs}
                createNew={false}
                createNewFunc={null}
                objectType="Funeral"
                itemId={this.props.match.params.id}
                name="CheckoutItem"
                context={this}
                readOnly={true}
            />
        );
    }
}

export default withErrorBoundary(compose(withRouter, withStyles(styles))(CheckoutItemView), {
    fallback: ErrorFallback
});
